<div class="container_b">
    <a class="btn btn-dark" data-toggle="collapse" href="#viewpoint" role="button" aria-expanded="false" aria-controls="collapseExample"><p>點選收合</p></a>

    <div class="collapse show" id="viewpoint">
      <div class="card card-body">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-item nav-link active" id="nav-all-tab" data-toggle="tab" href="#all" role="tab" aria-controls="nav-all" aria-selected="true"><img src="/static/images/svg/bt_all.svg" alt="全部">全部</a>
          <a class="nav-item nav-link" id="nav-view-tab" data-toggle="tab" href="#view" role="tab" aria-controls="nav-view" aria-selected="false"><img src="/static/images/svg/bt_view.svg" alt="景點">景點</a>
          <!-- <a class="nav-item nav-link" id="nav-food-tab" data-toggle="tab" href="#food" role="tab" aria-controls="nav-food" aria-selected="false"><img src="/static/images/svg/bt_food.svg" alt="餐廳">餐廳</a>
          <a class="nav-item nav-link" id="nav-rest-tab" data-toggle="tab" href="#rest" role="tab" aria-controls="nav-rest" aria-selected="false"><img src="/static/images/svg/bt_rest.svg" alt="住宿">住宿</a> -->
          <a class="nav-item nav-link" target="_blank" [href]='url + "/ch/buy-package/index"'><img src="/static/images/svg/bt_ticket.svg" alt="購買套票">購買套票</a>
          <a class="nav-item nav-link" target="_blank" [href]='url + "/ch/attractions/index"'><img src="/static/images/svg/bt_more.svg" alt="看更多">看更多</a>          
        </div>
      </nav>

      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="nav-all-tab">
          <div class="variable-width slick-all">
            @for(attraction of attractionArray; track $index){
            <div class="box">
                <a target="_blank" [href]='url + "/ch/attractions/view?uuid=" + attraction.uuid'>
                <div class="pic"><img [src]='url + "/files/" + attraction.imgPath' alt="圖說"></div>
                <div class="info">
                    <ul>
                        <li class="tt">{{ attraction.title }}</li>
                        <li class="w01">{{ getChLength(attraction.distance)  }}</li>
                        <li class="w02">{{ attraction.location }}</li>
                        <li class="w03">{{ attraction.openTime }}</li>
                    </ul>
                </div>
                </a>
            </div>
            }
          </div>
        </div>
        <div class="tab-pane fade" id="view" role="tabpanel" aria-labelledby="nav-view-tab">
            <div class="variable-width slick-view">
            @for(attraction of attractionArray; track $index){
                <div class="box">
                    <a target="_blank" [href]='url + "/ch/attractions/view?uuid=" + attraction.uuid'>
                    <div class="pic"><img [src]='url + "/files/" + attraction.imgPath' alt="圖說"></div>
                    <div class="info">
                        <ul>
                            <li class="tt">{{ attraction.title }}</li>
                            <li class="w01">{{ getChLength(attraction.distance) }}</li>
                            <li class="w02">{{ attraction.location }}</li>
                            <li class="w03">{{ attraction.openTime }}</li>
                        </ul>
                    </div>
                    </a>
                </div>
            }
            </div>
        </div>
        <!-- <div class="tab-pane fade" id="food" role="tabpanel" aria-labelledby="nav-food-tab">...</div>
        <div class="tab-pane fade" id="rest" role="tabpanel" aria-labelledby="nav-rest-tab">...</div> -->
        <div class="tab-pane fade" id="package" role="tabpanel" aria-labelledby="nav-package-tab">...</div>
        <div class="tab-pane fade" id="more" role="tabpanel" aria-labelledby="nav-more-tab">...</div>        
      </div>
    </div>
</div>
